export default __webpack_public_path__ + "static/media/playStore.64745614.png";